var T, add, ceil, createMatrix, creator, each, eachDiagonal, eachInRow, fail, failUnmatchingDimensions, floor, id, isNumber, makeReduce, matrixConstructor, matrixProto, matrixStatic, min, minus, sqrt;

creator = require("ut1l/create/object");

T = require("ut1l/create/throwable");

fail = T("MatrixException");

failUnmatchingDimensions = function() {
  return fail("invalid dimension");
};

floor = Math.floor, ceil = Math.ceil, sqrt = Math.sqrt, min = Math.min;

id = function(x) {
  return x;
};

add = function(a, b) {
  return a + b;
};

minus = function(a, b) {
  return a - b;
};

isNumber = function(n) {
  return typeof n === "number";
};

matrixConstructor = function(arrayOrRows, arrayOrColumns, arrayOpt) {
  var array, cols, rows;
  if (!isNumber(arrayOrRows)) {
    array = arrayOrRows;
  } else {
    rows = arrayOrRows;
    if (!isNumber(arrayOrColumns)) {
      array = arrayOrColumns;
    } else {
      cols = arrayOrColumns;
      array = arrayOpt;
    }
  }
  if (rows == null) {
    rows = ceil(sqrt(array.length));
  }
  if (cols == null) {
    cols = rows === 0 ? 0 : array != null ? ceil(array.length / rows) : rows;
  }
  if (array == null) {
    array = [];
  }
  this.columns = cols;
  this.rows = rows;
  this.array = array;
};

matrixStatic = {
  I: function(rows, columns) {
    var i, _i, _ref;
    if (columns == null) {
      columns = rows;
    }
    T = createMatrix(rows, columns);
    T.fill(0, T);
    for (i = _i = 0, _ref = min(rows, columns); _i < _ref; i = _i += 1) {
      T.set(i, i, 1);
    }
    return T;
  },
  diag: function(x, T) {
    if (T == null) {
      T = createMatrix(x.length, x.length);
    } else if (!T.isSize(x.length)) {
      failUnmatchingDimensions();
    }
    T.each(function(val, r, c) {
      return T.set(r, c, r === c ? x[r] : 0);
    });
    return T;
  }
};

eachInRow = function(row, handler) {
  var j, _i, _ref;
  for (j = _i = 0, _ref = this.columns; _i < _ref; j = _i += 1) {
    handler.call(this, this.get(row, j), row, j);
  }
  return this;
};

each = function(handler) {
  var i, _i, _ref;
  for (i = _i = 0, _ref = this.rows; _i < _ref; i = _i += 1) {
    eachInRow.call(this, i, handler);
  }
  return this;
};

eachDiagonal = function(handler) {
  var ij, _i, _ref;
  for (ij = _i = 0, _ref = min(this.rows, this.columns); _i < _ref; ij = _i += 1) {
    handler.call(this, this.get(ij, ij), ij, ij);
  }
  return this;
};

makeReduce = function(eachFunc) {
  return function(callback, initialValue) {
    var value;
    value = initialValue;
    eachFunc.call(this, function(val, i, j) {
      if (value != null) {
        value = callback.call(this, value, val, i, j);
      } else {
        value = val;
      }
    });
    return value;
  };
};

matrixProto = {
  get: function(row, col) {
    if (col == null) {
      col = 0;
    }
    return this.array[row * this.columns + col];
  },
  set: function(row, col, val) {
    this.array[row * this.columns + col] = val;
    return this;
  },
  isSize: function(rowsOrM, columns) {
    if (isNumber(rowsOrM)) {
      if (columns == null) {
        columns = rowsOrM;
      }
      return this.rows === rowsOrM && this.columns === columns;
    } else {
      return this.isSize(rowsOrM.rows, rowsOrM.columns);
    }
  },
  isSquare: function() {
    return this.rows === this.columns;
  },
  each: each,
  eachDiagonal: eachDiagonal,
  reduce: makeReduce(each),
  reduceDiagonal: makeReduce(eachDiagonal),
  reduceRows: function(callback, initialValue) {
    var i, j, rdcRows, val, value, _i, _j, _ref, _ref1;
    rdcRows = [];
    for (i = _i = 0, _ref = this.rows; _i < _ref; i = _i += 1) {
      value = initialValue;
      for (j = _j = 0, _ref1 = this.columns; _j < _ref1; j = _j += 1) {
        val = this.get(i, j);
        if (value != null) {
          value = callback.call(this, value, val, i, j);
        } else {
          value = val;
        }
      }
      rdcRows.push(value);
    }
    return rdcRows;
  },
  map: function() {
    var args, elements, func, l, n;
    args = arguments;
    n = args.length - 1;
    if (args[n] === void 0) {
      n -= 1;
    }
    if (typeof args[n] !== "function") {
      T = args[n--];
      if (!this.isSize(T)) {
        failUnmatchingDimensions();
      }
    } else {
      T = createMatrix(this.rows, this.columns);
    }
    func = args[n];
    l = T.rows * T.columns;
    elements = [];
    T.each((function(_this) {
      return function(val, i, j) {
        var k, _i;
        elements[0] = _this.get(i, j);
        for (k = _i = 0; _i < n; k = _i += 1) {
          elements[k + 1] = args[k].get(i, j);
        }
        elements[++k] = i;
        elements[++k] = j;
        return T.set(i, j, func.apply(_this, elements));
      };
    })(this));
    return T;
  },
  clone: function(T) {
    return this.map(id, T);
  },
  fill: function(s, T) {
    return this.map((function() {
      return s;
    }), T);
  },
  times: function(s, T) {
    return this.map((function(x) {
      return s * x;
    }), T);
  },
  add: function(B, T) {
    return this.map(B, add, T);
  },
  minus: function(B, T) {
    return this.map(B, minus, T);
  },
  transp: function(T) {
    var B, i, j, _i, _j, _ref, _ref1, _ref2;
    if (T == null) {
      T = createMatrix(this.columns, this.rows);
    }
    if (T === this) {
      B = this.clone();
      _ref = [this.columns, this.rows], this.rows = _ref[0], this.columns = _ref[1];
      return B.transp(this);
    } else {
      if (this.rows !== T.columns || this.columns !== T.rows) {
        failUnmatchingDimensions();
      }
      for (i = _i = 0, _ref1 = this.columns; _i < _ref1; i = _i += 1) {
        for (j = _j = 0, _ref2 = this.rows; _j < _ref2; j = _j += 1) {
          T.set(i, j, this.get(j, i));
        }
      }
      return T;
    }
  },
  mult: function(B, T) {
    var i, j, k, _i, _j, _k, _ref, _ref1, _ref2;
    if (T == null) {
      T = createMatrix(this.rows, B.columns);
    }
    if (this.columns !== B.rows || T.rows !== this.rows || T.columns !== B.columns) {
      failUnmatchingDimensions();
    }
    T.fill(0, T);
    for (i = _i = 0, _ref = this.rows; _i < _ref; i = _i += 1) {
      for (j = _j = 0, _ref1 = B.columns; _j < _ref1; j = _j += 1) {
        for (k = _k = 0, _ref2 = this.columns; _k < _ref2; k = _k += 1) {
          T.array[i * T.columns + j] += (this.get(i, k)) * (B.get(k, j));
        }
      }
    }
    return T;
  },
  toString: (function() {
    var concatEntries;
    concatEntries = function(x, y) {
      return x + " " + y;
    };
    return function() {
      return (this.reduceRows(concatEntries)).join("\n");
    };
  })()
};

module.exports = createMatrix = creator(matrixStatic, matrixConstructor, matrixProto);
